import {type KeyboardEvent} from "react";
import {components as ReactSelectComponents, GroupBase, type InputProps, SelectComponentsConfig} from "react-select";
import {css, cx} from "@panda/css";

import {ChevronDownIcon, EditIcon} from "@pg-design/icons-module";
import {IOption} from "@pg-design/select-module";
import {PingPongOverflowText} from "@pg-mono/ping-pong-overflow-text";

import {wizardTextInputStyle} from "../components/home_match_preferences_wizard/home_match_preferences_wizard_text_input_style";
import {HomeMatchUserPreferencesLocationPill} from "../components/home_match_user_preferences/HomeMatchUserPreferencesLocationPill";

interface IParams {
    hideIcons: boolean;
    isMobile: boolean | null;
    nextPlaceholder?: string;
    onLocationInputSelect: (inputValue: string) => void;
    visibleLocationChips: number;
}

const getLocationChipLabel = (label: string) => label.split(", ").pop() || label;

export const getHomeMatchUserPreferencesLocationSelectComponents = (
    params: IParams
): SelectComponentsConfig<IOption<number>, true, GroupBase<IOption<number>>> => {
    const {hideIcons, isMobile, nextPlaceholder, onLocationInputSelect, visibleLocationChips} = params;
    const rememberSelection = (inputValue: string) => onLocationInputSelect(inputValue);
    const rememberOnEnter = (inputProps: InputProps<IOption<number>, true, GroupBase<IOption<number>>>) => (event: KeyboardEvent<HTMLInputElement>) => {
        if (event.key === "Enter") rememberSelection(inputProps.selectProps.inputValue);

        inputProps.onKeyDown?.(event);
    };

    return {
        ...(hideIcons && {
            Placeholder: (placeholderProps) => (
                <ReactSelectComponents.Placeholder {...placeholderProps}>
                    {isMobile ? (
                        <PingPongOverflowText>
                            <span>{placeholderProps.children}</span>
                        </PingPongOverflowText>
                    ) : (
                        placeholderProps.children
                    )}
                </ReactSelectComponents.Placeholder>
            ),
            Control: (controlProps) => (
                <ReactSelectComponents.Control
                    {...controlProps}
                    innerProps={{
                        ...controlProps.innerProps,
                        className: cx(controlProps.innerProps.className, wizardTextInputStyle)
                    }}
                />
            )
        }),
        DropdownIndicator: hideIcons
            ? () => null
            : (indicatorProps) => (
                  <div className={editIconStyle}>
                      {indicatorProps.isFocused ? (
                          <ChevronDownIcon fill="var(--colors-gray-700)" size="2" />
                      ) : (
                          <EditIcon size="2" fill="var(--colors-secondary)" />
                      )}
                  </div>
              ),
        Input: (inputProps) => {
            const trackedProps = {...inputProps, onKeyDown: rememberOnEnter(inputProps)};

            if (!(hideIcons && nextPlaceholder) || !inputProps.hasValue) {
                return <ReactSelectComponents.Input {...trackedProps} />;
            }

            return (
                <div className={nextPlaceholderRowStyle}>
                    <ReactSelectComponents.Input {...trackedProps} />
                    {!inputProps.value && (
                        <div className={nextPlaceholderStyle}>
                            {isMobile ? (
                                <PingPongOverflowText>
                                    <span>{nextPlaceholder}</span>
                                </PingPongOverflowText>
                            ) : (
                                nextPlaceholder
                            )}
                        </div>
                    )}
                </div>
            );
        },
        Option: (optionProps) => (
            <ReactSelectComponents.Option
                {...optionProps}
                innerProps={{
                    ...optionProps.innerProps,
                    onMouseDown: (event) => {
                        rememberSelection(optionProps.selectProps.inputValue);
                        optionProps.innerProps.onMouseDown?.(event);
                    }
                }}
            />
        ),
        MultiValue: (multiValueProps) => {
            const values = multiValueProps.getValue();
            const hiddenCount = values.length - visibleLocationChips;

            if (hideIcons && multiValueProps.index >= visibleLocationChips) {
                return null;
            }

            return (
                <>
                    <HomeMatchUserPreferencesLocationPill neutral={hideIcons} removeProps={multiValueProps.removeProps}>
                        {hideIcons ? getLocationChipLabel(multiValueProps.data.label) : multiValueProps.data.label}
                    </HomeMatchUserPreferencesLocationPill>
                    {hideIcons && hiddenCount > 0 && multiValueProps.index === visibleLocationChips - 1 && (
                        <HomeMatchUserPreferencesLocationPill neutral>{`+${hiddenCount}`}</HomeMatchUserPreferencesLocationPill>
                    )}
                </>
            );
        }
    };
};

const editIconStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    width: "calc(var(--globals-baseUnit) * 3)",
    height: "calc(var(--globals-baseUnit) * 3)"
});

const nextPlaceholderRowStyle = css({
    alignItems: "center",
    display: "flex",
    flex: "1 1 auto",
    minWidth: "8rem",
    position: "relative"
});

const nextPlaceholderStyle = css({
    color: "var(--colors-gray-700)",
    left: 0,
    overflow: "hidden",
    pointerEvents: "none",
    position: "absolute",
    right: 0,
    top: "50%",
    transform: "translateY(-50%)",
    whiteSpace: "nowrap"
});
import {type KeyboardEvent} from "react";
import {components as ReactSelectComponents, GroupBase, type InputProps, SelectComponentsConfig} from "react-select";
import {css, cx} from "@panda/css";

import {ChevronDownIcon, EditIcon} from "@pg-design/icons-module";
import {IOption} from "@pg-design/select-module";
import {PingPongOverflowText} from "@pg-mono/ping-pong-overflow-text";

import {wizardTextInputStyle} from "../components/home_match_preferences_wizard/home_match_preferences_wizard_text_input_style";
import {HomeMatchUserPreferencesLocationPill} from "../components/home_match_user_preferences/HomeMatchUserPreferencesLocationPill";

interface IParams {
    hideIcons: boolean;
    isMobile: boolean | null;
    nextPlaceholder?: string;
    onLocationInputSelect: (inputValue: string) => void;
    visibleLocationChips: number;
}

const getLocationChipLabel = (label: string) => label.split(", ").pop() || label;

export const getHomeMatchUserPreferencesLocationSelectComponents = (
    params: IParams
): SelectComponentsConfig<IOption<number>, true, GroupBase<IOption<number>>> => {
    const {hideIcons, isMobile, nextPlaceholder, onLocationInputSelect, visibleLocationChips} = params;
    const rememberSelection = (inputValue: string) => onLocationInputSelect(inputValue);
    const rememberOnEnter = (inputProps: InputProps<IOption<number>, true, GroupBase<IOption<number>>>) => (event: KeyboardEvent<HTMLInputElement>) => {
        if (event.key === "Enter") rememberSelection(inputProps.selectProps.inputValue);

        inputProps.onKeyDown?.(event);
    };

    return {
        ...(hideIcons && {
            Placeholder: (placeholderProps) => (
                <ReactSelectComponents.Placeholder {...placeholderProps}>
                    {isMobile ? (
                        <PingPongOverflowText>
                            <span>{placeholderProps.children}</span>
                        </PingPongOverflowText>
                    ) : (
                        placeholderProps.children
                    )}
                </ReactSelectComponents.Placeholder>
            ),
            Control: (controlProps) => (
                <ReactSelectComponents.Control
                    {...controlProps}
                    innerProps={{
                        ...controlProps.innerProps,
                        className: cx(controlProps.innerProps.className, wizardTextInputStyle)
                    }}
                />
            )
        }),
        DropdownIndicator: hideIcons
            ? () => null
            : (indicatorProps) => (
                  <div className={editIconStyle}>
                      {indicatorProps.isFocused ? (
                          <ChevronDownIcon fill="var(--colors-gray-700)" size="2" />
                      ) : (
                          <EditIcon size="2" fill="var(--colors-secondary)" />
                      )}
                  </div>
              ),
        Input: (inputProps) => {
            const trackedProps = {...inputProps, onKeyDown: rememberOnEnter(inputProps)};

            if (!(hideIcons && nextPlaceholder) || !inputProps.hasValue) {
                return <ReactSelectComponents.Input {...trackedProps} />;
            }

            return (
                <div className={nextPlaceholderRowStyle}>
                    <ReactSelectComponents.Input {...trackedProps} />
                    {!inputProps.value && (
                        <div className={nextPlaceholderStyle}>
                            {isMobile ? (
                                <PingPongOverflowText>
                                    <span>{nextPlaceholder}</span>
                                </PingPongOverflowText>
                            ) : (
                                nextPlaceholder
                            )}
                        </div>
                    )}
                </div>
            );
        },
        Option: (optionProps) => (
            <ReactSelectComponents.Option
                {...optionProps}
                innerProps={{
                    ...optionProps.innerProps,
                    onMouseDown: (event) => {
                        rememberSelection(optionProps.selectProps.inputValue);
                        optionProps.innerProps.onMouseDown?.(event);
                    }
                }}
            />
        ),
        MultiValue: (multiValueProps) => {
            const values = multiValueProps.getValue();
            const hiddenCount = values.length - visibleLocationChips;

            if (hideIcons && multiValueProps.index >= visibleLocationChips) {
                return null;
            }

            return (
                <>
                    <HomeMatchUserPreferencesLocationPill neutral={hideIcons} removeProps={multiValueProps.removeProps}>
                        {hideIcons ? getLocationChipLabel(multiValueProps.data.label) : multiValueProps.data.label}
                    </HomeMatchUserPreferencesLocationPill>
                    {hideIcons && hiddenCount > 0 && multiValueProps.index === visibleLocationChips - 1 && (
                        <HomeMatchUserPreferencesLocationPill neutral>{`+${hiddenCount}`}</HomeMatchUserPreferencesLocationPill>
                    )}
                </>
            );
        }
    };
};

const editIconStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    width: "calc(var(--globals-baseUnit) * 3)",
    height: "calc(var(--globals-baseUnit) * 3)"
});

const nextPlaceholderRowStyle = css({
    alignItems: "center",
    display: "flex",
    flex: "1 1 auto",
    minWidth: "8rem",
    position: "relative"
});

const nextPlaceholderStyle = css({
    color: "var(--colors-gray-700)",
    left: 0,
    overflow: "hidden",
    pointerEvents: "none",
    position: "absolute",
    right: 0,
    top: "50%",
    transform: "translateY(-50%)",
    whiteSpace: "nowrap"
});
